// src/utils/epaIndex.js
// Trade name → EPA number lookup using Firestore index
// Seeded from WA PICOL commercial registration CSV
// This is used ONLY to find EPA numbers — all product data still comes live from PICOL API

import { db } from '../firebase';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';

// Search the Firestore epa_index by trade name (partial match)
export async function findEpaByTradeName(tradeName) {
  const searchTerm = tradeName.toLowerCase().trim();

  // Firestore doesn't support full-text search natively
  // We use a range query on nameLower for prefix matching
  // This catches "roundup" → "ROUNDUP ORIGINAL", "ROUNDUP PRO", etc.
  const indexRef = collection(db, 'epa_index');

  const q = query(
    indexRef,
    where('nameLower', '>=', searchTerm),
    where('nameLower', '<=', searchTerm + '\uf8ff'),
    limit(50)
  );

  const snapshot = await getDocs(q);
  const results = [];

  snapshot.forEach(doc => {
    results.push(doc.data());
  });

  // Also search for records where the name CONTAINS the search term
  // (prefix search misses "ROUNDUP ORIGINAL" when searching "original")
  // Do a second query for contains by checking common substrings
  if (results.length < 5) {
    const q2 = query(
      indexRef,
      where('nameLower', '>=', searchTerm.split(' ')[0]),
      where('nameLower', '<=', searchTerm.split(' ')[0] + '\uf8ff'),
      limit(50)
    );
    const snapshot2 = await getDocs(q2);
    snapshot2.forEach(doc => {
      const data = doc.data();
      // Only add if contains the full search term and not already in results
      if (
        data.nameLower.includes(searchTerm) &&
        !results.find(r => r.epa === data.epa && r.name === data.name)
      ) {
        results.push(data);
      }
    });
  }

  // Deduplicate by EPA number, collecting all matching trade names
  const epaMap = new Map();
  for (const r of results) {
    if (!epaMap.has(r.epa)) {
      epaMap.set(r.epa, { epa: r.epa, matchedNames: [], registrant: r.registrant });
    }
    epaMap.get(r.epa).matchedNames.push(r.name);
  }

  return Array.from(epaMap.values());
}
